<script setup>
  import { ref, watch } from 'vue';
  import { ITEMS_LIST_MODULE_NAME, useStore } from "../plugins/store";

  const { item } = defineProps({ item: Object });

  //region HISTORIC
  const visitItem = () => useStore().dispatch('visitItem', { item });
  //endregion

  //region RENDERING UTILS
  const highlightTerms = (input) => input.replace(new RegExp('(^|\\s)(' + item.highlightTerms.join('|') + ')($|\\s)','ig'), '$1<strong>$2</strong>$3');
  const showLatinTitle = item.titleLatin !== item.title;
  const showParent = item.parentTitle && item.parentPath;
  //endregion

  //region ACTIVE
  const isActive = () => item.hash === useStore().getters[ITEMS_LIST_MODULE_NAME + '/activeItem']?.hash;
  const onMouseEnter = () => {
    useStore().dispatch(ITEMS_LIST_MODULE_NAME + '/setActiveItem', { item });
  }
  const rootEl = ref(null);
  watch(() => isActive(), (isActive) => {
    if (isActive) {
      rootEl.value.scrollIntoView({ behavior: "instant", block: "nearest" })
    }
  });
  //endregion
</script>

<template>
  <div
      :class="[{'active': isActive()}, 'item-search', 'position-relative']"
      ref="rootEl"
      @mouseenter="onMouseEnter()"
  >
    <div class="icon-container">
      <div class="icon-search"
           :style="`background-image: url('${ item.iconPath }')`"
      >
      </div>
    </div>
    <div class="content-search">
      <a class="search-title-link stretched-link" :href="item.url" @click="visitItem()">
        <p class="search-title">
          <span class=" language-one" v-html="highlightTerms(item.title)"/>
          <template v-if="showLatinTitle"> - <span class="language-two" v-html="highlightTerms(item.titleLatin)"/></template>
        </p>
      </a>
      <p v-if="showParent" class="search-hierarchy">
        <a :href="item.parentPath">
          <span>{{ item.parentTitle }}</span>
        </a>
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
